import {decodeJwt} from "../../Checkout/Sections/PaymentDetails/CreditCard/ThreeDSecure/helpers/jwtHelper";

export function handleSubmission(
    microform,
    cart,
    cache,
    createMicroformTokenMutation,
    createCardinalTokenMutation,
    setMicroformPaymentDataMutation,
    setIsMfDataSubmitted,
    submitDdcForm,
    setIs3dsDisabled,
    basicPayload,
    cardType,
    setError
) {
    microform.createToken(
        {
            expirationMonth: cache.expirationMonth,
            expirationYear: cache.expirationYear
        },
        function (err, token) {
            if (err || !token) {
                setError('Sorry. There was an issue with your card details. Please contact support@nanoporetech.com ');
                return;
            }

            const decoded = decodeJwt(token);
            const card = decoded.content.paymentInformation.card // @TODO Error handling;

            createCardinalTokenMutation({
                variables: {
                    requestData: {
                        ...basicPayload,
                        token: token,
                        account_number: card.number.maskedValue,
                        exp_month: card.expirationMonth.value,
                        exp_year: card.expirationYear.value,
                        card_type: cardType,
                        browser_details: getBrowserDetails(),
                    }
                }
            }).then(ccaResponse => {
                const isEnabled = ccaResponse.data?.createCardinalToken?.is_enabled;
                setIs3dsDisabled(!isEnabled);
                if (isEnabled) submitCardinalDataCollection(submitDdcForm, ccaResponse);

                setMicroformPaymentDataMutation({
                    variables: {
                        paymentData: {
                            ...basicPayload,
                            token: token,
                            card_type: cardType,
                            exp_date: cache.expirationMonth + '-' + cache.expirationYear
                        }
                    }
                }).then(setPaymentDataResponse => {
                    setIsMfDataSubmitted(setPaymentDataResponse?.data?.setMicroformPaymentData?.success)
                })
            }).catch(err => {
                setError('Sorry. There was an issue with your card details. Please contact support@nanoporetech.com');
            })
        }
    );
}

function submitCardinalDataCollection(submitDdcForm, ccaData) {
    submitDdcForm(
        ccaData.data.createCardinalToken.device_data_collection_url,
        ccaData.data.createCardinalToken.access_token
    )
}

function getBrowserDetails() {
    return {
        screen_height: window.screen.height,
        screen_width: window.screen.width,
        time_difference: new Date().getTimezoneOffset(),
        color_depth: window.screen.colorDepth,
        java_enabled: false, // navigator.javaEnabled() is deprecated
        java_script_enabled: true,
        language: navigator.language,
        accept_content: window.navigator.userAgent,
    };
}
